// src/routes/login/DencadLogin.jsx
import { useState, useEffect, useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../api/AuthService';
import { AuthContext } from '../../components/authcontext/AuthContext';

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Video from '../../images/video.mp4';
import Logo from '../../images/aidite.jpg';

const DencadLogin = () => {
  const navigate = useNavigate();
  const { updateUser } = useContext(AuthContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const loginApi = useCallback(async () => {

    try {
      const formData = new FormData();
      
      if (!email) {
        toast.error("please enter email", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }
      
      if (!password) {
        toast.error("please enter password", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }

      setLoading(true);
      
      formData.append('email', email);
      formData.append('password', password);

      const result = await AuthService.login(formData);

      if (result?.data?.success === true) {
        localStorage.setItem("token", result?.data?.data?.user?.token);
        updateUser(result?.data?.data?.user);
        navigate('/dashboard');
        
        toast.success(result?.data?.message, {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      toast.error(error?.result?.data?.errors?.[0] || "An error occurred", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  }, [email, password, updateUser, navigate]); // Add dependencies used inside the function

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        loginApi();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [loginApi]);

  return (
    <>
      {loading && <div className="loader-parent"><div className="_loader"></div></div>}
      <div className='login-wrapper login-main bio'>
        <video autoPlay loop muted className="background-video">
          <source src={Video} type="video/mp4" />
        </video>
        <div className='form-wrapper'>
          <div className="left-section">
            
            {/* Optional: Wrapping inputs in a form is standard HTML practice */}
            <div className="form-group">
              <label htmlFor="email">User Id</label>
              <input id="email" type="text" className='input'
               value={email} onChange={(e) => setEmail(e.target.value)} 
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" className='input'
               value={password} onChange={(e) => setPassword(e.target.value)} 
              />
            </div>
            <div className="d-flex justify-content-center my-3">
              <button className="button" onClick={loginApi}>Login</button>
            </div>
            <div className="copy-text mt-4">
              Powered by Clear Care Tech | Copyright © 2024 | All Rights Reserved
            </div>
          </div>
          <div className="right-section">
            <div className="image">
              <img src={Logo}  className='circle' alt="Logo" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DencadLogin